import angular from 'angular';
import activityItemsTemplate from './activityItems.html';

/*****************************************************************************
 * Component: activityItems */
/**
 * @ngdoc     component
 * @module    csm.books.fundraisers
 * @name      csm.books.fundraisers.component:activityItems
 * @description
 * Component definition object for {@link activityItems}. The component is used to
 * manage grid content for the `activity` component which is used for the Cost and
 * Sales tabs. This component requires the `activity` component as its parent.
 *****************************************************************************/
export const activityItemsComponent = {
  bindings: { forCosts: '<', gridData: '<', total: '<' },
  controller: ActivityItemsController,
  template: activityItemsTemplate
};

/*****************************************************************************
 * Controller: ActivityItemsController */
/**
 * @ngdoc     controller
 * @module    csm.books.fundraisers
 * @methodof  csm.books.fundraisers.activityItems.controller:ActivityItemsController
 * @description
 * Main controller for {@link activityItems}.
 *****************************************************************************/
/* @ngInject */ function ActivityItemsController($injector, $scope) {
  var $ctrl = this;
  $ctrl.dgActivityItems = $injector.invoke(buildGridOptions, null, {
    $ctrl: $ctrl
  });
  $ctrl.$onChanges = $injector.invoke($onChanges, null, { $ctrl: $ctrl });
}

/*****************************************************************************
 * buildGridOptions */
/**
 * @ngdoc    function
 * @name     buildGridOptions
 * @methodOf csm.books.fundraisers.activityItems.controller:ActivityItemsController
 * @returns  {object} uiGrid definition object
 * @description
 * Builds and returns the grid definition object.
 *****************************************************************************/
/* @ngInject */ function buildGridOptions(uiGridConstants, $ctrl) {
  return {
    enableColumnMenus: false,
    enableColumnResizing: true,
    enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    minRowsToShow: 8,
    maxRowsToShow: 8,
    onRegisterApi: function (api) {
      $ctrl.gridApi = api;
    },
    columnDefs: [
      {
        cellFilter: 'date:"MM/dd/yyyy"',
        field: 'date',
        type: 'date',
        width: 90
      },
      {
        field: 'type',
        width: 150
      },
      {
        field: 'number',
        type: 'numberStr',
        width: 90
      },
      {
        field: 'description',
        type: 'string',
        width: 420
      },
      {
        cellClass: 'text-right',
        cellFilter: 'number:2',
        field: 'amount',
        type: 'number',
        width: 90
      }
    ]
  };
}

/*****************************************************************************
 * $onChanges */
/**
 * @ngdoc    function
 * @name     $onChanges
 * @methodOf csm.books.fundraisers.activityItems.controller:ActivityItemsController
 * @description
 * This is called automatically by angular when any of the bound properties
 * changes. When either the grid data or total amount change, their respective
 * models are updated.
 *****************************************************************************/
/* @ngInject */ function $onChanges($ctrl) {
  return function (changes) {
    if (changes.gridData) {
      $ctrl.dgActivityItems.data = changes.gridData.currentValue;
      $ctrl.gridApi ? $ctrl.gridApi.core.refresh() : angular.noop;
    }

    if (changes.total) $ctrl.actualTotal = changes.total.currentValue;
  };
}
